import { MatProgressButtonOptions } from 'mat-progress-buttons';
import { cloneDeep } from 'lodash-es';

const btnOpts: MatProgressButtonOptions = {
  active: false,
  text: '',
  buttonColor: 'accent',
  barColor: 'accent',
  raised: false,
  stroked: false,
  flat: true,
  mode: 'indeterminate',
  value: 0,
  disabled: false,
  customClass: 'backtest-action-button ut-pro-button gradient submit-button margin-8-hr height-36',
};

export function getProgressButtonOptions(name: string) {
  const option = cloneDeep(btnOpts);
  option.text = name

  return option;
}
